module.exports = __webpack_public_path__ + "img/Dessert.8807c267.jpg";